class VeyoMenu extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.details?.addEventListener('toggle', () => {
      document.body.classList.toggle('menu-open', this.details.open);
    });
  }
}
customElements.define('veyo-menu', VeyoMenu);

document.addEventListener('click', (event) => {
  const filter = event.target.closest('[data-product-filter]');
  if (!filter) return;
  const value = filter.dataset.productFilter;
  const section = filter.closest('[data-filter-section]');
  section.querySelectorAll('[data-product-filter]').forEach((button) => button.setAttribute('aria-pressed', String(button === filter)));
  let count = 0;
  section.querySelectorAll('[data-product-card]').forEach((card) => {
    card.hidden = value !== 'all' && card.dataset.productType.toLowerCase() !== value.toLowerCase();
    if (!card.hidden) count += 1;
  });
  const output = section.querySelector('[data-product-count]');
  if (output) output.textContent = `${count} ${count === 1 ? 'style' : 'styles'}`;
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const form = select.closest('form');
  const option = select.options[select.selectedIndex];
  const button = form.querySelector('[type="submit"]');
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.querySelector('span').textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }
});

const adviser = document.querySelector('#veyo-ai-adviser');
const adviserMessages = adviser?.querySelector('[data-ai-messages]');
const adviserInput = adviser?.querySelector('[data-ai-input]');

function openVeyoAdviser() {
  if (!adviser) return;
  if (typeof adviser.showModal === 'function' && !adviser.open) adviser.showModal();
  adviserInput?.focus();
}

function adviserReply(question) {
  const text = question.toLowerCase();
  if (/cycl|ride|road|bike|sport/.test(text)) return '<p><strong>VEYO S · $199 AUD</strong> is the cycling-focused choice: an 8 MP hands-free camera, stabilised 1080p video, open-ear audio and a 52 g sports frame.</p><a href="/products/veyo-s-ai-cycling-glasses-camera">View VEYO S ↗</a>';
  if (/best camera|camera|photo|video|capture/.test(text)) return '<p><strong>VEYO X · $299 AUD</strong> leads the range for imaging with its 13 MP Sony camera and stabilised 1080p video. For cycling-specific capture, VEYO S is the better fit.</p><a href="/products/veyo-x-ai-camera-glasses">View VEYO X ↗</a>';
  if (/travel|battery|charging|journey|trip/.test(text)) return '<p><strong>VEYO N · $268 AUD</strong> is designed for travel. Its 2000 mAh charging case extends use away from a power point, while the 35 g frame stays light.</p><a href="/products/veyo-n-ai-glasses-charging-case">View VEYO N ↗</a>';
  if (/translat|language|lens|everyday/.test(text)) return '<p><strong>VEYO P · $169 AUD</strong> is the everyday value choice, with an 8 MP Sony camera, app-based translation, open-ear audio and three lens choices.</p><a href="/products/veyo-p-ai-translation-camera-glasses">View VEYO P ↗</a>';
  if (/under|budget|cheap|price|cost|afford|\$/.test(text)) return '<p>Under $200, choose <strong>VEYO P · $169 AUD</strong> for everyday translation and camera features, or <strong>VEYO S · $199 AUD</strong> for cycling and stabilised ride video.</p><a href="/collections/all">Compare all products ↗</a>';
  if (/ship|deliver|return|warrant|order/.test(text)) return '<p>For delivery, returns, warranty or an existing order, the FAQ has the current store guidance. A person can help with order-specific details.</p><a href="/pages/faq">Read the FAQ ↗</a><a href="/pages/contact"> Contact support ↗</a>';
  if (/hello|hi|hey/.test(text)) return '<p>Hello. I can compare VEYO X, N, P and S by activity, camera, travel needs or budget. What matters most to you?</p>';
  return '<p>Based on the current range: VEYO X is the flagship camera model, VEYO N is made for travel, VEYO P focuses on everyday translation and value, and VEYO S is built for cycling. Tell me your activity, top feature and budget for a closer match.</p><a href="/collections/all">See all four models ↗</a>';
}

function addAdviserMessage(question) {
  if (!adviserMessages || !question.trim()) return;
  const userMessage = document.createElement('div');
  userMessage.className = 'ai-message ai-message--user';
  const userText = document.createElement('p');
  userText.textContent = question.trim();
  userMessage.appendChild(userText);
  adviserMessages.appendChild(userMessage);

  const guideMessage = document.createElement('div');
  guideMessage.className = 'ai-message ai-message--guide';
  guideMessage.innerHTML = `<span>VEYO</span><div>${adviserReply(question)}</div>`;
  adviserMessages.appendChild(guideMessage);
  adviserMessages.scrollTop = adviserMessages.scrollHeight;
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('a[href$="#veyo-ai-adviser"], [data-ai-adviser-open]');
  if (opener) {
    event.preventDefault();
    openVeyoAdviser();
    return;
  }
  if (event.target.closest('[data-ai-adviser-close]')) adviser?.close();
  const prompt = event.target.closest('[data-ai-prompt]');
  if (prompt) addAdviserMessage(prompt.dataset.aiPrompt);
});

adviser?.addEventListener('click', (event) => {
  if (event.target === adviser) adviser.close();
});

adviser?.querySelector('[data-ai-form]')?.addEventListener('submit', (event) => {
  event.preventDefault();
  addAdviserMessage(adviserInput.value);
  adviserInput.value = '';
  adviserInput.focus();
});

if (window.location.hash === '#veyo-ai-adviser') openVeyoAdviser();
